import React from 'react'

export function TextStatics({ tpEstado }) {
  const returnText = () => {
    switch (tpEstado) {
      case '1':
        return 'Em preparação'
      case '2':
        return 'Confirmado'
      case '3':
        return 'Em Atendimento Médico'
      case '5':
        return 'Atendimento Médico Finalizado'
      case '6':
        return 'Finalizado'
      default:
        return 'Iniciando Cadastro'
    }
  }
  const returnCor = () => {
    switch (tpEstado) {
      case '1':
        return '#D4D672'
      case '2':
        return '#67aabf'
      case '3':
        return '#59c57d'
      case '5':
        return '#D4D672'
      case '6':
        return '#1A9042'
      default:
        return '#757575'
    }
  }
  return (
    <div className="flex items-center gap-2">
      <div
        style={{
          width: '15px',
          height: '15px',
          backgroundColor: returnCor(),
          borderRadius: '100px',
        }}
      />
      {returnText()}
    </div>
  )
}
